// import request from "@/utils/request"; 
export const queryPage = "/integral/api/integral/userIntegralInfo";
